/**
 * @fileoverview Agent definition for world-organization-snapshotter-v3.
 *
 * This agent analyzes a chapter and updates a world organization's state,
 * creating a snapshot that reflects any changes from the chapter events.
 *
 * @category world-building.organizations.snapshots
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-organization-snapshotter-v3',
  kind: 'primitive',
  name: 'World Organization Snapshotter',
  description: 'Updates a world organization state after a chapter, creating a point-in-time snapshot.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.organizations.snapshots',
    usedBy: ['use-world-organization-snapshotter-v3.ts'],
    usedInComposites: [],
    relatedAgents: ['world-organization-details-generator-v3'],
  },
};
